import { useState } from "react";

import { useTranslation } from "@impero-com/common/utils/i18n";
import { canGoBack } from "@impero-com/common/utils/url";
import { Button, InformationModal } from "@impero-com/ui";
import { useNavigate } from "react-router-dom";

import { Footer } from "components/modals/Footer";

interface ViewCancelButtonProps {
    isDirty: boolean;
    /** Names what the unsaved changes belong to. The title is always the same. */
    bodyLabel: string;
}
export function ViewCancelButton({
    isDirty,
    bodyLabel,
}: ViewCancelButtonProps) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [dialogOpen, setDialogOpen] = useState(false);

    const handleCancel = () => {
        if (canGoBack(history)) {
            navigate(-1);
        } else {
            navigate("/");
        }
    };

    const handleClick = () => {
        if (isDirty) {
            setDialogOpen(true);
        } else {
            handleCancel();
        }
    };

    return (
        <>
            <Button size="large" variant="default" onClick={handleClick}>
                {t("Cancel")}
            </Button>
            <InformationModal
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                type="error"
                icon="unsavedChanges"
                title={t("Dialog_DiscardChanges_Title")}
                footer={
                    <Footer
                        onClose={() => setDialogOpen(false)}
                        onConfirm={handleCancel}
                        confirmLabel={t("Discard")}
                        cancelLabel={t("KeepEditing")}
                        destructive
                    />
                }
            >
                {bodyLabel}
            </InformationModal>
        </>
    );
}
